module.exports = __webpack_public_path__ + "static/media/33.f4152769.jpg";